import React, { useMemo } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectUser } from "../../../core/auth/authSlice";
import { User } from "../../../shared/models";
import SelectCartellinoPref from "../components/SelectCartellinoPref";
import SelectCategory from "../components/SelectCategory";
import SelectLeague from "../components/SelectLeague";
import SelectPosition from "../components/SelectPosition";
import SelectSport from "../components/SelectSport";
import SelectStaff from "../components/SelectStaff";

const Step3SportsInfo: React.FC = () => {
	const { t } = useTranslation();
	const { accountType } = useSelector(selectUser) as User;
	const { watch } = useFormContext();
	const watchSubject = watch("subject");

	const sportsInfoContent = useMemo(() => {
		switch (accountType) {
			case "athlete":
				switch (watchSubject) {
					case "team":
						return (
							<>
								<div className="column-group w-100">
									<SelectSport />
									<SelectCategory />
									<SelectPosition label={t("createJob.positionLabel")} />
									<SelectLeague />
								</div>
							</>
						);
					case "staff":
						return (
							<>
								<div className="column-group w.100">
									<SelectStaff label={t("createJob.whichPositionLookingFor")} />
								</div>
							</>
						);
					default:
						return null;
				}
			case "team":
				switch (watchSubject) {
					case "athlete":
						return (
							<>
								<div className="column-group w-100">
									<SelectSport />
									<SelectCategory />
									<SelectPosition label={t("createJob.positionLabel")} />
									<SelectLeague />
									<SelectCartellinoPref />
								</div>
							</>
						);
					case "staff":
						return (
							<>
								<div className="column-group w-100">
									<SelectStaff label={t("createJob.whichPositionLookingFor")} />
								</div>
							</>
						);
					default:
						return null;
				}
			case "techStaff":
			case "medStaff":
			case "management":
				return (
					<>
						<div className="column-group w-100">
							<SelectSport />
							<SelectCategory />
						</div>
					</>
				);
			default:
				return null;
		}
	}, [watchSubject, accountType, t]);

	return <div className="step-content">{sportsInfoContent}</div>;
};

export default Step3SportsInfo;
